import { Component, Injector, Input, OnInit } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { BaseChart } from 'src/app/core/data/model';
import { ChartType } from 'src/app/shared/common';
import { BaseComponent } from '../../base-component/base.component';

@Component({
  standalone: true,
  selector: 'app-base-chart',
  template: ``,
})
export abstract class BaseChartComponent<T extends BaseChart> extends BaseComponent implements OnInit {
  @Input() labels: string[] = [];
  @Input() data: T[] | number[] = [];
  @Input() colors: string[] = [];
  @Input() public showLegend: boolean = true;
  @Input() public legendPosition: 'bottom' | 'left' | 'top' | 'right' | 'center' = 'bottom';
  @Input() public chartOptions: ChartConfiguration['options'];
  abstract chartType: ChartType;
  constructor(injector: Injector) {
    super([], injector);
  }

  //hooks
  ngOnInit(): void {
    this.setChartConfigs();
    this.buildChartData();
  }
  // protected
  protected abstract buildChartData(): void;

  protected setChartConfigs(): void {
    this.chartOptions = {
      responsive: true,
      plugins: {
        legend: {
          display: true,
          position: this.legendPosition,
          labels: {
            usePointStyle: true,
            boxWidth: 15,
            textAlign:'left'
          },
        },
        tooltip: {
          enabled: true,
        },
      },
    };
  }
}
